import React from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { BookmarkCheckIcon, BookmarkPlusIcon, XIcon } from "lucide-react";
import { SpeakButton } from "../games/SpeakButton";
import { spring } from "../../utils/motion";
interface WordSheetProps {
  word: {
    term: string;
    translation: string;
  } | null;
  saved: boolean;
  speechLang: string;
  onSave: () => void;
  onClose: () => void;
}
export function WordSheet({
  word,
  saved,
  speechLang,
  onSave,
  onClose
}: WordSheetProps) {
  const reduce = useReducedMotion() ?? false;
  return <AnimatePresence data-id="element-1171" data-mp="119s7rv09gj7">
      {word && <motion.div role="dialog" aria-label={`Translation of ${word.term}`} initial={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 24,
      transition: {
        duration: 0.15
      }
    }} transition={spring.stable} className="fixed inset-x-4 bottom-24 z-50 mx-auto max-w-md rounded-card border-3 border-line bg-surface p-4 shadow-brutal-lg lg:bottom-8" data-id="element-1172" data-mp="3igqa4si2fxtb">
          <div className="flex items-center gap-3" data-id="element-1173" data-mp="3dg69234phf6z">
            <SpeakButton text={word.term} lang={speechLang} data-id="element-1174" data-mp="3ddjydumiqjkj" />
            <div className="min-w-0 flex-1" data-id="element-1175" data-mp="3r7l0mycoiopn">
              <p className="truncate text-xl font-bold text-ink" lang="es" data-id="element-1176" data-mp="3mg2zoaanoo4o">
                {word.term}
              </p>
              <p className="truncate text-[15px] text-ink-2" data-id="element-1177" data-mp="4z1w69j9dy8u">{word.translation}</p>
            </div>
            <button type="button" onClick={onClose} aria-label="Close" className="focus-ring rounded-lg p-1.5 text-ink-2 hover:text-ink" data-id="element-1178" data-mp="1044z3uuol8">
              <XIcon className="h-5 w-5" data-id="element-1179" data-mp="dzq2sj6bowbp" />
            </button>
          </div>
          <button type="button" onClick={onSave} disabled={saved} className={`focus-ring mt-3 flex w-full items-center justify-center gap-2 rounded-xl border-3 border-line px-4 py-2.5 text-sm font-semibold transition-colors duration-150 ${saved ? "bg-good-tint text-ink" : "bg-accent text-night"}`} data-id="element-1180" data-mp="9zpp50r1sp5p">
            {saved ? <BookmarkCheckIcon className="h-4 w-4" data-id="element-1181" data-mp="jpj8vcnxpwsy" /> : <BookmarkPlusIcon className="h-4 w-4" data-id="element-1182" data-mp="jqkm9nsfavdu" />}
            {saved ? "In My Words — it'll show up in lessons" : "Save to My Words"}
          </button>
        </motion.div>}
    </AnimatePresence>;
}